export default __webpack_public_path__ + "static/affiliate-program-Software-2-e93c388a42a7e438c6f9bd60c7829a9e.jpg";